import template from './deductible-status-item.html'

ko.components.register('deductible-status-item', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo, widgetInfo) {
            return new DeductibleStatusItem(params, widgetInfo.updateHeight);
        }
    }
});

function getStatusTranslation(status) {
    const translations = {
        'No Deductible': $.cdh.languageConstant.getConstant('DeductibleStatus.lblNoDeductible'),
        'Deductible Met': $.cdh.languageConstant.getConstant('DeductibleStatus.lblDeductibleMet'),
        'Not Met': $.cdh.languageConstant.getConstant('DeductibleStatus.lblDeductibleNotMet'),
        'Limited': $.cdh.languageConstant.getConstant('DeductibleStatus.lblLimitedDeductible')
    };
    return translations[status] || status;
}

function DeductibleStatusItem(params, updateHeight) {
    const self = this;
    const model = params.model;

    self.id = model.id;
    self.startDate = model.startDate;
    self.endDate = model.endDate;
    self.status = getStatusTranslation(model.status);
    self.deductible = model.deductible;
    self.oldMetDate = model.metDate;
    self.canSet = model.canSet;

    self.attestationText = model.attestationText;
    self.attestationURL = model.attestationURL;
    self.attestationURLText = model.attestationURLText;

    self.isChangingDetails = model.isChanging;

    self.maxDate = moment() > self.endDate ? self.endDate : moment();

    self.changeStatus = function () {
        self.isChangingDetails(true);
        recalcWidgetsHeights();
    };
    
    self.isSubmitting = model.isSubmitting;
    
    self.changeStatusModel = {
        id: self.id,
        status: self.status,
        oldMetDate: self.oldMetDate,
        startMetDate: self.startDate,
        endMetDate: self.maxDate,
        isParentSubmitting: self.isSubmitting,
        attestationText: self.attestationText,
        attestationURL: self.attestationURL,
        attestationURLText: self.attestationURLText
    };

    self.changeStatusModel.submit = function (isMet, metDate) {
        model.submit({
            isStatusMet: isMet,
            metDate: metDate
        });
    };

    self.changeStatusModel.cancel = function() {
        self.isChangingDetails(false);
    };

    updateHeight();
}